import Pagination from "@/components/common/Pagination.vue";

export default {
  data() {
    return {
      Pagination: {
        total: 0,
        page: 1,
        page_size: 10,
      },
    };
  },
  components: {
    Pagination,
  },
  methods: {
    // 分页查询
    handleCurrentChange(val = 1) {
      this.Pagination.page = val;
      this.getData();
    },
    resetCurrent() {
      this.Pagination = {
        total: 0,
        page: 1,
        page_size: 10,
      };
    },
  },
  computed: {
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
  },
};
